import React, { useContext, useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import FormInputMobile2 from 'modules/common/components/FormInputMobile2';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import useFormValidator from 'useFormValidator';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import * as action from '../action';
import * as c from '../constant';
import PinModalContainer from './PinModalContainer';

const form = {
  first_name: '',
  middle_name: '',
  last_name: '',
  extension_name: '',
  email: '',
  birth_date: '',
  password: '',
  password_confirmation: '',
  mobile_number: '',
};

function AddSubscriberModal({
  updating,
  // showTransaction,
  // getTransactionList,
  createAccount,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    birth_date: 'required',
    email: 'required_if_no_mobile',
    mobile_number: 'required_if_no_email',
    password: 'required|password',
    password_confirmation: 'required|match:password|password',
  });

  const handleCloseAttempt = useCallback(
    (e) => {
      if (e) {
        e.preventDefault();
      }
      // eslint-disable-next-line
      const confirmClose = window.confirm(
        'Are you sure you want to close? Any unsaved changes will be lost.'
      );

      if (confirmClose) {
        setModal({ isOpen: false });
      }
    },
    [setModal]
  );

  // Modify the escape key handler to use confirmation
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        handleCloseAttempt(e);
      }
    };

    document.addEventListener('keydown', handleEscapeKey, true);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey, true);
    };
  }, [handleCloseAttempt]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      first_name: _.get(formData, 'first_name').toUpperCase(),
      middle_name: _.get(formData, 'middle_name').toUpperCase(),
      last_name: _.get(formData, 'last_name').toUpperCase(),
      is_resident: 0,
      mobile_number:
        _.get(formData, 'mobile_number') !== '63'
          ? _.get(formData, 'mobile_number')
          : '',
    };
    createAccount(args, () => {
      setModal({
        isOpen: true,
        content: (
          <PinModalContainer
            mobileNo={args.mobile_number}
            password={formData.password}
          />
        ),
        title: 'Enter OTP for this mobile number',
        modalSize: 'modal-md',
      });
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              First Name: {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">Middle Name:</label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Last Name: {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="extension_name" className="form-label mb-0">
              Extension Name
            </label>
            <Select
              name="extension_name"
              onChange={handleOnChangeSelect('extension_name')}
              options={c.EXTENSION_NAMES}
              value={
                c.EXTENSION_NAMES.find(
                  (item) =>
                    _.get(formData, 'extension_name') === _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Mobile Number&nbsp;
              {validateForm.renderMessage('mobile_number')}
            </label>
            <FormInputMobile2
              value={formData.mobile_number}
              onChange={onChange}
              // error={validateForm.getError('mobile_number')}
              disabled={updating}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">Email Address:</label>{' '}
            {validateForm.renderMessage('email')}
            <input
              className="form-control"
              type="email"
              name="email"
              onChange={onChange}
              value={_.get(formData, 'email') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Birth Date: {validateForm.renderMessage('birth_date')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('birth_date')}
              value={_.get(formData, 'birth_date') || ''}
              maxDate={new Date()}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Password: {validateForm.renderMessage('password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password"
              onChange={onChange}
              value={_.get(formData, 'password') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Confirm Password:{' '}
              {validateForm.renderMessage('password_confirmation')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password_confirmation"
              onChange={onChange}
              value={_.get(formData, 'password_confirmation') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-12">
            <div className="alert alert-info mt-3 p-3" role="alert">
              Password must have minimum of 12 characters, 1 uppercase, 1
              lowercase, 1 symbol, and 1 number
            </div>
          </div>
        </div>
        <hr />

        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              formData.password !== formData.password_confirmation
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={handleCloseAttempt}
            className="mt-3 btn btn-dark mr-3 "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
AddSubscriberModal.propTypes = {
  updating: PropTypes.bool.isRequired,
  // showTransaction: PropTypes.instanceOf(Function).isRequired,
  createAccount: PropTypes.instanceOf(Function).isRequired,
  // getTransactionList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CREATE_ACCOUNT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(AddSubscriberModal);
